// frontend/src/pages/ChatPage/ChatPage.js
// Purpose: Displays the ChatGPT multimodal chat interface.
// Desired purpose: Provides users with an interactive chat for text and image uploads.

import React from 'react';
import Chat from '../../components/Chat/Chat';
import './ChatPage.css';

const ChatPage = () => {
    return (
        <div className="chat-page">
            <h1>Multimodal Chat</h1>
            <Chat />
        </div>
    );
};

export default ChatPage;